
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { Team } from './types';

interface NewTeamDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreateTeam: (team: Team) => void;
}

const NewTeamDialog: React.FC<NewTeamDialogProps> = ({ 
  open, 
  onOpenChange, 
  onCreateTeam 
}) => {
  const [newTeamName, setNewTeamName] = useState('');
  const { toast } = useToast();

  const handleCreateTeam = () => {
    if (!newTeamName.trim()) {
      toast({
        title: "Error",
        description: "Team name cannot be empty",
        variant: "destructive",
      });
      return;
    }

    const newTeam: Team = {
      id: `team-${Date.now()}`,
      name: newTeamName,
      members: []
    };

    onCreateTeam(newTeam);
    setNewTeamName('');
    onOpenChange(false);
    
    toast({
      title: "Team Created",
      description: `${newTeamName} team has been created successfully.`,
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create New Team</DialogTitle>
          <DialogDescription>
            Enter a name for your new team. You can add members later.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label htmlFor="team-name">Team Name</Label>
            <Input 
              id="team-name" 
              placeholder="e.g. Engineering, Marketing, etc."
              value={newTeamName}
              onChange={(e) => setNewTeamName(e.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button onClick={handleCreateTeam}>
            Create Team
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default NewTeamDialog;
